import { ScrollSpy } from "bootstrap";
if (document.querySelector("#arkefip-tab-menu-mobile")) {
  new ScrollSpy(document.body, { target: "#arkefip-tab-menu-mobile" })
}